<template>
  <div class="app-container">
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" class="demo-form-inline" label-width="100px" size="mini">
        <div class="formItemBox">
          <el-form-item label="登记日期">
            <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="searchFrom.value1" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="队列">
            <el-select v-model="searchFrom.queueId" placeholder="请选择">
                <el-option v-for="item in duilieList" :key="item.queueName" :label="item.queueName"
                    :value="item.id">
                </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车辆号牌">
            <el-input size="mini" v-model.trim="searchFrom.vehicleNo" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="业务单号">
            <el-input size="mini" v-model.trim="searchFrom.no" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="发货单位:">
            <el-select v-model="searchFrom.deliveryCompanyName"  placeholder="请选择" filterable clearable>
              <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
              :value="item.custerName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="收货单位:">
            <el-select v-model="searchFrom.receiveCompanyName"  placeholder="请选择" filterable clearable>
              <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
              :value="item.custerName"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div style="margin:0 0 8px 10px;">
          <el-form-item>
            <el-button type="primary" @click="searchFn" btnCode="01K00E0100" v-if="btnFlg[0]">查询</el-button>
            <el-button type="primary" @click="resetForm" btnCode="01K00E0200"
                v-if="btnFlg[1]">重置</el-button>
            <el-button type="primary" @click="daochu" btnCode="01K00E0300" v-if="btnFlg[2]">导出</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{ height: h }">
      <el-table :data="tableList" ref="table" bordersize="mini" @selection-change='selectGoods' style="width: 100%" height="100%" center border class="tableComent">
        <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini" @click="zyllFn(scope.row)">作业履历</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="deliveryCompanyName" label="发货单位" align="center" width="200"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="receiveCompanyName" label="收货单位" align="center" width="200"></el-table-column>
        <el-table-column prop="queueName" label="作业队列" width="120"></el-table-column>
        <el-table-column prop="vehicleNo" width="100" label="车牌号"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="mobilePhone" label="手机号" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="jobStatusName" label="状态" align="center" width="120">
          <template slot-scope="scope">
            <div>
              <!-- 1：排队中 2：已叫号 3：已过号 4：已失效 5：已进仓 6：进仓过磅完成 7：出仓过磅完成 8：出仓过副磅完成 9：已出仓 -->
              <span v-if="scope.row.jobStatusName == '排队中'" style="color:blue">排队中
              </span>
              <span v-else-if="scope.row.jobStatusName == '已叫号'" style="color:red">已叫号
              </span>
              <span v-else-if="scope.row.jobStatusName == '已过号'" style="color:rgb(242, 159, 25)">已过号
              </span>
              <span v-else>{{ scope.row.jobStatusName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="dataDiff" label="作业时长" width="100">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.dataDiff">{{ scope.row.dataDiff }}分钟</span>
              <span v-else></span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="entryWeighing" label="进仓过磅重量(吨)" align="center" width="140"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="exitMainWeighing" label="出仓过磅重量(吨)" align="center" width="140"></el-table-column>
        <el-table-column width="160" prop="registrationTime" label="登记时间"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="callStationTime" label="叫号时间" align="center" width="160"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="mobilizationTime" label="进仓时间" align="center" width="160"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="entryWeighingTime" label="进仓过磅时间" align="center" width="160"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="exitMainTime" label="出仓过磅时间" align="center" width="160"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="exFactoryTime" label="出仓时间" align="center" width="160"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="no" label="业务单号" align="center" width="200"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="originalTon" label="装货地净重" align="center" width="110"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="grossWeight" label="装货地毛重" align="center" width="110"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="tareWeight" label="装货地皮重" align="center" width="110"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="unloadUser" label="装卸人" align="center" width="140"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="unloadTime" label="装卸时间" align="center" width="170"></el-table-column>
        <el-table-column prop="lineUpNo" label="排队序号" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="statusUpdateUser" label="修改人" align="center" width="80"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="statusUpdateTime" label="修改时间" align="center" width="160"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="searchFrom.pageNo" :page-sizes="[20, 30, 40, 50]" :page-size="searchFrom.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
    </div>
    <el-dialog title="作业履历" :visible.sync="zyMark" width="600px" class="detail"  :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
      <div class="table">
        <div class="vertical-steps">
          <div v-for="(step, index) in steps" :key="index" :class="['step', step.status, step.className]">
            <div class="step-line" v-if="index < steps.length - 1"></div>
            <div class="step-icon">
              <i>{{ step.icon }}</i>
            </div>
            <div class="step-content">
              <div class="step-title">{{ step.title }}</div>
              <div class="step-description">{{ step.description }}</div>
              <div class="demo-image__preview" style="display: flex;" v-if="step.title == '入库确认' && instockImg.length > 0">
                <span v-for="(item, index) in instockImg" :key="index">
                  <!-- 点击小图触发预览 -->
                  <img
                    :src="item.imgUrl"
                    @click="openPreview(index,1)"
                    alt="磅单图片"
                    style="width:50px;height:50px;margin:0 10px 0 0;border-radius:5px;cursor:zoom-in;"
                  />
                </span>
              </div>
              <div class="demo-image__preview" style="display: flex;" v-if="step.title == '出库确认' && BDimgList.length > 0">
                <span v-for="(item, index) in BDimgList" :key="index">
                  <!-- 点击小图触发预览 -->
                    <img
                      :src="item.fileKeyUrl"
                      @click="openPreview(index,2)"
                      alt="磅单图片"
                      style="width:50px;height:50px;margin:0 10px 0 0;border-radius:5px;cursor:zoom-in;"
                    />
                </span>
              </div>
              <div class="demo-image__preview" style="display: flex;" v-if="step.title == '登记' && DJimgList.length > 0">
                <span v-for="(item, index) in DJimgList" :key="index">
                  <!-- 点击小图触发预览 -->
                    <img
                      :src="item.fileKeyUrl"
                      @click="openPreview(index,3)"
                      alt="随车磅单"
                      style="width:50px;height:50px;margin:0 10px 0 0;border-radius:5px;cursor:zoom-in;"
                    />
                </span>
              </div>
              <div class="demo-image__preview" style="display: flex;" v-if="step.title == '装卸货' && ZXimgList.length > 0">
                <span v-for="(item, index) in ZXimgList" :key="index">
                  <!-- 点击小图触发预览 -->
                    <img
                      :src="item.fileKeyUrl"
                      @click="openPreview(index,4)"
                      alt="装卸凭证"
                      style="width:50px;height:50px;margin:0 10px 0 0;border-radius:5px;cursor:zoom-in;"
                    />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="zyMark = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 引入全屏预览组件 -->
    <image-fullscreen-preview
      :visible="previewVisible"
      :image-list="previewImageList"
      :initial-index="currentPreviewIndex"
      @close="handlePreviewClose"
    ></image-fullscreen-preview>
  </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import DonMessage from '@/utils/message'
import { exportExcel } from '@/utils/fileDown.js'
import { getOutStockReceip, getRelationCustomer } from '@/api/wms-stock'
import { billList } from '@/api/wms-access'
import { getHistoryList, getQueueSettingsList, getJobStatusList, getInstockInfo, getOutstockInfo, findFlieUrl, findFlieUnloadUrl } from '@/api/lj'
import ImageFullscreenPreview from '@/views/lj/ImageFullscreenPreview.vue'
export default {
  components: {
    ImageFullscreenPreview // 注册全屏预览组件
  },
  data () {
    return {
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 20
      },
      total: 0,
      duilieList: [],
      zhuangtaiList: [],
      btnFlg: [],
      btnIdArr: ['01K00E0100', '01K00E0200', '01K00E0300'],
      zyMark: false,
      active: 0,
      currentStep: 0,
      steps: [],
      instockDate: '',
      outstockDate: '',
      previewVisible: false, // 控制预览组件显示/隐藏
      previewImageList: [], // 传给预览组件的图片列表（仅存url）
      currentPreviewIndex: 0, // 当前点击图片的索引
      BDimgList: [], // 原有图片列表（含fileKeyUrl等信息，保持不变）
      instockImg: [],
      RKData: [],
      DJimgList: [],
      ZXimgList: []
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/exitHistory')
    this.getList()
    getQueueSettingsList(this.searchFrom).then(res => {
      this.duilieList = res
    }).catch(err => {
      DonMessage.error(err.message)
    })
    getJobStatusList(this.searchFrom).then(res => {
      this.zhuangtaiList = res
    }).catch(err => {
      DonMessage.error(err.message)
    })
    // 字典-查询客户
    getRelationCustomer({
      // groupNo: "change_status"
    })
      .then((res) => {
        this.RKData = res
      })
      .catch((err) => {
        DonMessage.error(err.message)
      })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 165) + 'px'
  },
  methods: {
    // 点击导出
    daochu () {
      exportExcel(
        this.global.lj + '/factory/exHistoryList',
        { ...this.searchFrom },
        '进出历史表'
      )
    },
    // 审核
    passClick (row) {
      this.addFrom = { ...row }
      this.drawerFlag = true
    },
    successFn () {
      this.getList()
    },
    destroy () {
      this.drawerFlag = false
    },

    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 获取列表
    getList () {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      // let result = this.duilieList.find((item) => {
      //     return item.id == this.searchFrom.queueId
      // })
      // this.searchFrom.queueName = result.queueName
      // let resultq = this.zhuangtaiList.find((item) => {
      //     return item.id == this.searchFrom.itemNo
      // })
      // this.searchFrom.jobStatusName = resultq.showName
      // this.searchFrom.jobStatus = this.searchFrom.itemNo
      if (this.searchFrom.value1) {
        this.searchFrom.registrationTimeStart = this.searchFrom.value1[0]
        this.searchFrom.registrationTimeEnd = this.searchFrom.value1[1]
      }
      getHistoryList(this.searchFrom).then(res => {
        this.tableList = res.list
        this.total = res.total
        loading.close()
      }).catch(err => {
        loading.close()

        DonMessage.error(err.message)
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 20,
        registrationTimeStart: '',
        registrationTimeEnd: '',
        value1: ''
      }
      this.getList()
    },
    closeDialog () {
      this.zyMark = false
    },
    async zyllFn (row) {
      this.zyMark = true

      // 使用async/await确保异步操作完成后再生成步骤
      if (row.jobType == '卸货') { // 入库
        await this.getInstockInfo(row.id)
      } else { // 出库
        await this.getOutstockInfo(row.id)
      }
      await this.findFlieUrl(row.id)
      await this.findFlieUnloadUrl(row.id)
      // 等待异步操作完成后生成步骤
      this.$nextTick(() => {
        const steps = this.generateStepsByStatus(row)
        this.steps = steps
      })
    },
    // 新增方法：根据状态生成步骤
    generateStepsByStatus (row) {
      const stepConfigs = [
        {
          key: 'start',
          title: '开始',
          description: '流程开始',
          status: 'completed',
          className: 'step-start', // 开始步骤：紫色
          icon: 'S',
          alwaysShow: true
        },
        {
          key: 'register',
          title: '登记',
          description: row.registrationTime || '登记时间',
          status: 'completed',
          className: 'step-start', // 新增：继承开始颜色
          icon: '1',
          timeField: 'registrationTime'
        },
        {
          key: 'call',
          title: '叫号',
          description: row.callStationTime || '叫号时间',
          status: 'waiting',
          className: 'step-start', // 新增：继承开始颜色
          icon: '2',
          timeField: 'callStationTime'
        },
        {
          key: 'entry',
          title: '进仓',
          description: row.mobilizationTime || '进仓时间',
          status: 'waiting',
          className: 'step-start', // 新增：继承开始颜色
          icon: '3',
          timeField: 'mobilizationTime'
        },
        {
          key: 'weighing',
          title: '进仓过磅',
          description: row.entryWeighingTime || '进仓过磅时间',
          status: 'waiting',
          className: 'step-start', // 新增：继承开始颜色
          icon: '4',
          timeField: 'entryWeighingTime'
        },
        // 新增的装卸货步骤
        {
          key: 'unload',
          title: '装卸货',
          description: row.unloadTime || '装卸货时间',
          status: 'waiting',
          className: 'step-start',
          icon: '5',
          timeField: 'unloadTime'
        },
        {
          key: 'exit',
          title: '出仓过磅',
          description: row.exitMainTime || '出仓过磅时间',
          status: 'waiting',
          className: 'step-start', // 新增：继承开始颜色
          icon: '6',
          timeField: 'exitMainTime'
        },
        {
          key: 'instockConfirm',
          title: '入库确认',
          description: row.instockDate || '入库时间',
          status: 'waiting',
          className: 'step-start', // 新增：继承开始颜色
          icon: '7',
          timeField: 'instockDate'
        },
        {
          key: 'outstockConfirm',
          title: '出库确认',
          description: row.outstockDate || '出库时间',
          status: 'waiting',
          className: 'step-start', // 新增：继承开始颜色
          icon: '8',
          timeField: 'outstockDate'
        },
        {
          key: 'exFactory',
          title: '出仓',
          description: row.exFactoryTime || '出仓时间',
          status: 'waiting',
          className: 'step-start', // 新增：继承开始颜色
          icon: '9',
          timeField: 'exFactoryTime'
        },
        {
          key: 'end',
          title: '结束',
          description: '流程完成',
          status: 'waiting',
          className: 'step-end', // 结束步骤：绿色
          icon: 'E',
          alwaysShow: true
        }
      ]

      // 根据状态返回不同的步骤数组
      const statusStepMap = {// start开始、register登记、call叫号、entry进仓、weighing进仓过磅
        // exit出仓过磅、instockConfirm入库确认、outstockConfirm出库确认 exFactory出厂 end结束
        '1': ['start', 'register', 'end'],
        '2': ['start', 'register', 'call', 'end'],
        '3': ['start', 'register', 'call', 'end'],
        '4': ['start', 'register', 'call', 'end'],
        '5': ['start', 'register', 'call', 'entry', 'end'],
        '6': ['start', 'register', 'call', 'entry', 'weighing', 'unload', 'end'], // 状态6显示卸货
        '7': ['start', 'register', 'call', 'entry', 'weighing', 'unload', 'exit', 'end'], // 修改了状态7
        '8': ['start', 'register', 'call', 'entry', 'weighing', 'unload', 'exit', 'instockConfirm', 'outstockConfirm', 'end'], // 修改了状态8
        '9': ['start', 'register', 'call', 'entry', 'weighing', 'unload', 'exit', 'instockConfirm', 'outstockConfirm', 'exFactory', 'end'] // 修改了状态9
      }

      // 获取当前状态对应的步骤key
      const stepKeys = statusStepMap[row.jobStatus] || ['start', 'end']
      // 过滤步骤：如果步骤有时间字段但该字段为空，则过滤掉该步骤
      const filteredSteps = stepKeys.map(key => stepConfigs.find(config => config.key === key))
        .filter(stepConfig => {
          if (!stepConfig) return false
          // 始终显示的步骤不过滤
          if (stepConfig.alwaysShow) return true

          // 检查时间字段是否有值
          if (stepConfig.timeField) {
            if (stepConfig.key === 'unload') {
              return row[stepConfig.timeField] // 装卸货步骤必须有时间才显示
            }
            return row[stepConfig.timeField] // 只有时间字段有值才显示
          }
          return true
        }).map(stepConfig => ({
          title: stepConfig.title,
          description: stepConfig.description || this.getStepDescription(stepConfig, row), // 使用动态描述
          status: 'waiting', // 初始状态，后面会更新
          className: stepConfig.className,
          icon: stepConfig.icon
        }))
      // 更新步骤状态
      this.updateStepStatusByJobStatus(filteredSteps, row.jobStatus, stepKeys)
      return filteredSteps
    },
    getStepDescription (stepConfig, row) {
      if (stepConfig.timeField) {
        return row[stepConfig.timeField] || '暂无时间'
      }
      return stepConfig.description || ''
    },
    // 状态更新方法
    updateStepStatusByJobStatus (steps, jobStatus, originalStepKeys) {
      const statusMap = {
        '1': 1, // 登记步骤为processing
        '2': 2, // 叫号步骤为processing
        '3': 3, // 进仓步骤为processing
        '4': 4, // 进仓过磅步骤为processing
        '5': 5, // 装卸货步骤为processing（新增）
        '6': 6, // 出仓过磅步骤为processing
        '7': 7, // 入库确认为processing
        '8': 8, // 出库确认为processing
        '9': 9 // 出厂为processing
      }

      const currentStepIndex = statusMap[jobStatus] || 0

      // 由于步骤被过滤了，需要重新计算当前步骤在过滤后数组中的位置
      let filteredCurrentIndex = 0
      let count = 0

      // 找到当前步骤在过滤后数组中的位置
      for (let i = 0; i < originalStepKeys.length; i++) {
        const stepKey = originalStepKeys[i]
        // 检查这个步骤是否在过滤后的数组中
        const existsInFiltered = steps.some(step =>
          step.title === this.getStepTitleByKey(stepKey)
        )

        if (existsInFiltered) {
          if (i === currentStepIndex) {
            filteredCurrentIndex = count
            break
          }
          count++
        }
      }

      steps.forEach((step, index) => {
        if (index === 0) {
          step.status = 'completed'
        } else if (index === steps.length - 1) {
          step.status = filteredCurrentIndex >= steps.length - 1 ? 'end' : 'waiting'
        } else if (index < filteredCurrentIndex) {
          step.status = 'completed'
        } else if (index === filteredCurrentIndex) {
          step.status = 'processing'
        } else {
          step.status = 'waiting'
        }
      })
    },
    // 辅助方法：根据key获取步骤标题
    getStepTitleByKey (key) {
      const titleMap = {
        'start': '开始',
        'register': '登记',
        'call': '叫号',
        'entry': '进仓',
        'weighing': '进仓过磅',
        'unload': '装卸货', // 新增
        'exit': '出仓过磅',
        'instockConfirm': '入库确认',
        'outstockConfirm': '出库确认',
        'exFactory': '出厂',
        'end': '结束'
      }
      return titleMap[key] || key
    },
    // 入库
    getInstockInfo (id) {
      return new Promise((resolve, reject) => {
        getInstockInfo({
          id: id
        }).then(res => {
          console.log(res, '22222')
          if (res) {
            this.instockDate = res.instockDate
            // 出库时也需要等待获取磅单图片完成
            return this.getinstockDj(res.instockId)
          } else {
            this.instockDate = ''
            resolve(null)
          }
        }).then(() => {
          this.tableList.forEach(item => {
            if (id == item.id) {
              this.$set(item, 'instockDate', this.instockDate)
            }
          })
          resolve()
        }).catch(err => {
          DonMessage.error(err.message)
          reject(err)
        })
      })
    },
    // 出库
    getOutstockInfo (id) {
      return new Promise((resolve, reject) => {
        getOutstockInfo({
          id: id
        }).then(res => {
          console.log(res, '333333')
          if (res) {
            this.outstockDate = res.outstockDate
            // 出库时也需要等待获取磅单图片完成
            return this.getOutStockReceip(res.outstockId)
          } else {
            this.outstockDate = ''
            resolve(null)
          }
        }).then(() => {
          this.tableList.forEach(item => {
            if (id == item.id) {
              this.$set(item, 'outstockDate', this.outstockDate)
            }
          })
          resolve()
        }).catch(err => {
          DonMessage.error(err.message)
          reject(err)
        })
      })
    },
    getOutStockReceip (outstockId) {
      return new Promise((resolve, reject) => {
        getOutStockReceip({
          outstockId: outstockId
        })
          .then(res => {
            if (res) {
              this.BDimgList = res
            } else {
              this.BDimgList = []
            }
            resolve(res)
          })
          .catch(error => {
            DonMessage.error(error.message)
            this.BDimgList = []
            reject(error)
          })
      })
    },
    getinstockDj (instockId) {
      return new Promise((resolve, reject) => {
        billList(instockId)
          .then(res => {
            if (JSON.stringify(res) != '{}') {
              this.instockImg = res.receipt_on_vehicle
            } else {
              this.instockImg = []
            }
            resolve(res)
          })
          .catch(error => {
            DonMessage.error(error.message)
            this.instockImg = []
            reject(error)
          })
      })
    },
    // 登记-随车磅单
    findFlieUrl (id) {
      return new Promise((resolve, reject) => {
        findFlieUrl({
          id: id
        })
          .then(res => {
            this.DJimgList = []
            if (res) {
              this.DJimgList.push({
                fileKeyUrl: res
              })
              // console.log(this.DJimgList, 'this.DJimgList')
            } else {
              this.DJimgList = []
            }
            resolve(res)
          })
          .catch(error => {
            DonMessage.error(error.message)
            this.DJimgList = []
            reject(error)
          })
      })
    },
    // 装卸凭证
    findFlieUnloadUrl (id) {
      return new Promise((resolve, reject) => {
        findFlieUnloadUrl({
          id: id
        })
          .then(res => {
            this.ZXimgList = []
            if (res) {
              this.ZXimgList.push({
                fileKeyUrl: res
              })
              // console.log(this.ZXimgList, 'this.ZXimgList')
            } else {
              this.ZXimgList = []
            }
            resolve(res)
          })
          .catch(error => {
            DonMessage.error(error.message)
            this.ZXimgList = []
            reject(error)
          })
      })
    },
    /**
   * 打开预览（点击小图时触发）
   * @param {Number} index - 当前点击图片的索引
   */
    openPreview (index, flag) {
    // 从BDimgList中提取图片url，传给预览组件
      if (flag == 1) {
        this.previewImageList = this.instockImg.map(item => item.imgUrl)
      } else if (flag == 2) {
        this.previewImageList = this.BDimgList.map(item => item.fileKeyUrl)
      } else if (flag == 3) {
        this.previewImageList = this.DJimgList.map(item => item.fileKeyUrl)
      } else if (flag == 4) {
        this.previewImageList = this.ZXimgList.map(item => item.fileKeyUrl)
      }

      this.currentPreviewIndex = index // 记录当前点击的索引
      this.previewVisible = true // 显示预览组件
    },

    /**
   * 关闭预览（组件关闭时触发）
   */
    handlePreviewClose () {
      this.previewVisible = false
    // 可选：清理预览数据（避免内存占用）
    // this.previewImageList = [];
    }

  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
    margin-left: 10px;
}

.inpBox .el-date-editor {
    width: 350px !important;
}
.vertical-steps {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 500px;
    position: relative;
    padding: 20px 0;
}

.step {
    display: flex;
    margin-bottom: 20px;
    position: relative;
    opacity: 0;
    transform: translateY(20px);
    animation: fadeInUp 0.6s forwards;
}

.step:nth-child(1) { animation-delay: 0.1s; }
.step:nth-child(2) { animation-delay: 0.2s; }
.step:nth-child(3) { animation-delay: 0.3s; }
.step:nth-child(4) { animation-delay: 0.4s; }
.step:nth-child(5) { animation-delay: 0.5s; }
.step:nth-child(6) { animation-delay: 0.6s; } /* 新增的装卸货步骤 */
.step:nth-child(7) { animation-delay: 0.7s; } /* 原步骤6变成7 */
.step:nth-child(8) { animation-delay: 0.8s; } /* 原步骤7变成8 */
.step:nth-child(9) { animation-delay: 0.9s; } /* 原步骤8变成9 */
.step:nth-child(10) { animation-delay: 1.0s; } /* 原步骤9变成10 */
.step:nth-child(11) { animation-delay: 1.1s; } /* 原步骤10变成11 */
@keyframes fadeInUp {
    to {
    opacity: 1;
    transform: translateY(0);
    }
}

.step-line {
    position: absolute;
    left: 13px;
    top: 35px;
    width: 2px;
    height: calc(100% - 20px);
    // background-color: #e0e0e0;
    z-index: 1;
    background-color: #409EFF !important; // 改为与开始步骤一致的紫色
}
// 结束步骤前的线仍为紫色（与其他步骤一致）
.step-end ~ .step-line {
  display: none; // 结束步骤后无连接线，隐藏
}
.step-icon {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
    z-index: 2;
    position: relative;
    transition: all 0.3s ease;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.step-icon i {
    font-size: 16px;
    color: white;
}

.step-content {
    flex: 1;
    padding-top: 3px;
}

.step-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 5px;
    color: #2c3e50;
    transition: color 0.3s ease;
}

.step-description {
    color: #7f8c8d;
    font-size: 14px;
    line-height: 1.5;
}

.step.active .step-icon {
    transform: scale(1.1);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.step.active .step-title {
    color: #3498db;
}

// .step.completed .step-icon {
//   background-color: #2ecc71;
// }
// .step.completed .step-icon {
//     background-color: #409EFF;
// }
// .step.waiting .step-icon {
//     background-color: #bdc3c7;
// }

// .step.processing .step-icon {
//     background-color: #3498db;
//     animation: pulse 1.5s infinite;
// }

// @keyframes pulse {
//     0% {
//     box-shadow: 0 0 0 0 rgba(52, 152, 219, 0.7);
//     }
//     70% {
//     box-shadow: 0 0 0 10px rgba(52, 152, 219, 0);
//     }
//     100% {
//     box-shadow: 0 0 0 0 rgba(52, 152, 219, 0);
//     }
// }

.step-start .step-icon {
    background-color: #409EFF;
}

.step-end .step-icon {
    // background-color: #e74c3c;
    background-color: #2ecc71;
}

// 1. 基础步骤样式：清除原有状态色，让 step-start/step-end 类生效
.step .step-icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  z-index: 2;
  position: relative;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  // 清除原有状态色（completed/waiting/processing）的默认背景，避免干扰
  background-color: transparent !important;
}

// 2. 开始步骤 + 所有显示的步骤：统一紫色（与开始一致）
.step.step-start .step-icon {
  background-color: #409EFF !important; // 强制紫色，优先级最高
}

// 3. 结束步骤：固定绿色
.step.step-end .step-icon {
  background-color: #2ecc71 !important; // 强制绿色，优先级最高
}

// 4. 保留原有动画和文字样式（不变）
.step-icon i {
  font-size: 16px;
  color: white;
}
.step.active .step-icon {
  transform: scale(1.1);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}
.step.active .step-title {
  color: #3498db;
}
.step-description {
  color: #7f8c8d;
  font-size: 14px;
  line-height: 1.5;
}
</style>
